import { PropsWithChildren } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { BookingWidget } from '../../third-party/microsoft/booking-widget';
import {
  TALKIATRY_PHONE_NUMBER_DISPLAY,
  TALKIATRY_PHONE_NUMBER_TEL_URL,
} from '../../../helpers/const';
import { AssessmentCard } from '../shared';
import { Icon } from '../../icon/icon';

export const FinalWithBookingWidget = ({ children }: PropsWithChildren<{}>) => (
  <>
    <AssessmentCard>
      {children}
      <BookingWidget />
    </AssessmentCard>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 2,
      }}
    >
      <Typography variant="subtitle1" textAlign="center" sx={{ mb: 1 }}>
        Can't find a time? Get in touch:
      </Typography>
      <Stack
        spacing={1}
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
      >
        <Button
          href={TALKIATRY_PHONE_NUMBER_TEL_URL}
          startIcon={<Icon icon="Phone" />}
        >
          {TALKIATRY_PHONE_NUMBER_DISPLAY}
        </Button>
        <Button
          href="mailto:appointments@talkiatry.com"
          startIcon={<Icon icon="Envelope" />}
        >
          appointments@talkiatry.com
        </Button>
      </Stack>
    </Box>
  </>
);
